import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EVENTS } from '@app/constants/events.constants';
import { DeleteSecuritykeyComponent } from '@app/modules/vault/components/securitykey/components/delete-securitykey/delete-securitykey.component';
import { SecurityStepperComponent } from '@app/modules/vault/components/securitykey/components/security-stepper/security-stepper.component';
import { DocumentService, UserService } from '@app/shared/services';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TruncateStrPipe } from '@app/shared/pipes/truncate-str.pipe';
@AutoUnsubscribe()
@Component({
    selector: 'app-add-premium-key-dialog',
    templateUrl: './add-premium-key-dialog.component.html',
    imports: [
      CommonModule,
      MatTooltipModule,
      TruncateStrPipe
    ]
})
export class AddPremiumKeyDialogComponent implements OnInit, OnDestroy {
  premiumKeys = [];
  @Input() currentUser;
  subscription: Subscription = new Subscription();
  is_loading: boolean = false;
  constructor(private dialog: MatDialog, private documentService: DocumentService, private userService: UserService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.getLatestKeys();
  }

  onSubmit(): void {
    // Handle form submission
  }

  onCancel(): void {}
  addNewKey() {
    const dialogRef = this.dialog.open(SecurityStepperComponent, {
      panelClass: 'full-window-dialog',
      disableClose: true,
      data: { showkeyName: true, showSecurityKey: true, showHint: true, showSafeguardKey: true },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res.confirmation) {
          this.userService.trackEventsInMixPanel([{ eventName: EVENTS.security_privacy_premium_keys_change }]).then((response) => {});
        }
        this.getLatestKeys();
      })
    );
  }
  getLatestKeys() {
    this.is_loading = true;
    this.getSecurityKey();
  }
  getSecurityKey() {
    this.premiumKeys = [];
    this.subscription.add(
      this.documentService.getSecurityKeyWidhId(this.currentUser.id).subscribe((res) => {
        this.is_loading = false;
        if (res.length && res[0].keys.Items) {
          this.premiumKeys = res[0].keys.Items;
        } else {
          this.premiumKeys = [];
          // this.openSecurityKeyDialog();
        }
        this.cd.detectChanges();
      })
    );
  }

  deleteSeuritykey(key) {
    const dialogKeyRef = this.dialog.open(DeleteSecuritykeyComponent, {
      panelClass: 'security-key-dialog-2',
      data: { currentKey: key, keyName: key.keyName },
    });

    this.subscription.add(
      dialogKeyRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.getLatestKeys();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.userService.cleanupWorker();
  }
}
